import { Component, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FormControl } from '@angular/forms';
import { LanguageService } from '../../../../services/language.service';

@Component({
    selector: 'formly-multi-language-select',
    styles: [
        `
      .icon {
        width: 24px;
        height: 16px;
        object-fit: cover;
        border-radius: 2px;
        margin-right: 8px;
      }
      .selected-item {
        display: flex;
        align-items: center;
        padding: 2px 6px;
        border-radius: 4px;
        background-color: rgba(63, 45, 89, 0.1);
        margin: 2px;
      }
      .remove-btn {
        cursor: pointer;
        margin-left: 6px;
        font-weight: bold;
        color: #6c757d;
      }
      .remove-btn:hover {
        color: #dc3545;
      }
    `,
    ],
    template: `
    <div *ngIf="shouldShowLabel" class="form-label">
      {{ props.label }}
      <span *ngIf="props.required">*</span>
    </div>

    <ng-select
      [items]="items"
      bindLabel="name"
      bindValue="value"
      [multiple]="true"
      [clearable]="false"
      [searchable]="true"
      [formControl]="control"
      placeholder=" ">
      <ng-template ng-label-tmp let-item="item">
        <div class="selected-item">
          <ng-container *ngIf="props['showIcons']">
            <img [src]="getIconSrc(item.value)" class="icon" alt="{{ item.name }} icon"/>
          </ng-container>
          <span class="filter-label">{{ item.name }}</span>
          <span class="remove-btn" (mousedown)="removeItem($event, item)">×</span>
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        <div class="d-flex align-items-center justify-content-between">
          <span class="filter-label">{{ item.name }}</span>
          <ng-container *ngIf="props['showIcons']">
            <img [src]="getIconSrc(item.value)" class="icon" alt="{{ item.name }} icon"/>
          </ng-container>
        </div>
      </ng-template>
    </ng-select>
  `,
    standalone: false
})
export class FormlyMultiSelectComponent
  extends FieldType
  implements AfterViewInit
{
  items: { value: string; name: string }[] = [];

  constructor(
    private languageService: LanguageService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  async ngAfterViewInit() {
    const languages = await this.languageService.getLanguages();

    this.items = languages.map((lang) => ({
      value: lang.languageCode,
      name: this.getLanguageName(lang.languageCode),
    }));
    
    this.cdr.detectChanges();
  }

  get control(): FormControl {
    return this.formControl as FormControl;
  }

  get shouldShowLabel(): boolean {
    return this.props['showLabel'] !== false;
  }

  getIconSrc(code: string): string {
    if (this.props['showIcons']) {
      return this.props['getIconSrc']
        ? this.props['getIconSrc'](code)
        : `https://flagcdn.com/w320/${code}.png`;
    }
    return '';
  }

  removeItem(event: Event, item: any) {
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
    const currentValue = this.control.value || [];
    this.control.setValue(currentValue.filter((v: any) => v !== item.value));
    return false;
  }

  getLanguageName(code: string): string {
    const mapping: Record<string, string> = {
      gb: 'English',
      it: 'Italian',
      al: 'Albanian',
      fr: 'French',
      es: 'Spanish',
      de: 'German',
      ru: 'Russian',
    };
    return mapping[code] || code;
  }
}